// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__38M09","inputWrap":"styles_inputWrap__33IoP","input":"styles_input__2zKM2"};